export default {
  'aws.title': 'Amazon 訂單',
  'aws.business': '產品/訂單 ID',
  'aws.orderStatus': '訂單狀態',
  'aws.aswStatus': '亞馬遜訂閱狀態',
  'aws.orderInfo': '訂單資訊',
  'aws.expireTime': '截止時間',
  'aws.createTime': '建立時間',
  'aws.pending': '待激活',
  'aws.unbind': '待綁定',
  'aws.bound': '已綁定',
  'aws.cancelled': '已取消',
  'aws.activeText': '{time} 後激活',
  'aws.operate': '操作',
  'aws.bindTips': '訂單待激活，暫不可操作',
  'aws.bind': '綁定',
  'aws.engageLabOrder': 'EngageLab 訂單',
  'aws.whatsapp.recharge': '儲值',
  'aws.whatsapp.recharge.price': '儲值金額',
  'aws.apppush.dataCenter': '數據中心',
  'aws.apppush.dau': 'DAU',
  'aws.apppush.vip': 'VIP 時長',
  'aws.email.tips': '郵件包/流量/獨立 IP 數',
  'aws.email': '郵件數量',
  'aws.email.ip': '獨立 IP 數量',
  'aws.email.flow': '充流量',
  'aws.choose.service': '選擇 EngageLab 服務',
  'aws.choose.organization': '組織',
  'aws.choose.nodata': '無應用',
  'aws.choose.whatsapp': 'WhatsApp 商業帳戶',
  'aws.choose.app': '應用',

  'aws.order.title': '綁定 Amazon 訂單',
  'aws.order.information': 'Amazon 訂單信息',
  'aws.order.id': '訂單 ID',
  'aws.order.product': '產品類型',
  'aws.bind.success': '綁定成功',
  'aws.bind.modal.create': '創建{appName}',
  'aws.month': '{number} 個月',
  'aws.allBusiness': '所有產品',
  'aws.order.status': '訂單狀態',
  'aws.aswStatus.refunded': '已退款',
  'aws.aswStatus.expired': '已到期',
  'aws.aswStatus.subscribed': '已訂閱',
  'aws.aswStatus.upgraded': '已升級',
  'aws.aswStatus.renewed': '自動續購',
  'aws.aswStatus.cancelled': '已取消',
  'aws.aswStatus.refunded.tips': '本訂單已在 Amazon 申請退款，具體事宜請聯繫商務處理',
  'aws.aswStatus.upgraded.tips':
    '本訂單在 Amazon 進行了升級，如需在 EngageLab 享受升級後的權益，請聯繫銷售協助處理。升級後的套餐如下：',
  'aws.bindTips.cancelled': '訂單已在亞馬遜取消',
  'aws.bindTips.unbind': '訂單已在亞馬遜 {status}，請聯繫商務處理',
  'aws.bindTips.unbind.status.refunded': '退款',
  'aws.bindTips.unbind.status.expired': '到期',
  'aws.bindTips.unbind.status.upgraded': '升級',
  'aws.bindTips.unbind.status': '退款/到期/升級',
  'aws.nodata': '暫無數據',
  'aws.jumpEmail':
    '請前往<a href="https://www.engagelab.com/console/email/#/email/{orgid}/sendSetting/domain" target="_blank">Email</a>配置域名',
};
